// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__RHgsx","approved":"Status_approved__ITmaC","rejected":"Status_rejected__2J5AN","expired":"Status_expired__3hZp-","label":"Status_label__BmS_R"};